<template>
  <div>
    <Report
      module="Estoque"
      name="Produtos por Cliente"
      urlGet="/api/v1/stock/report/product-customer"
      :header="header"
      :filters="filters"
    />
  </div>
</template>

<script>
import Report from "@nixweb/nixloc-ui/src/component/report/Report";

export default {
  name: "ReportProductByCustomerView",
  components: {
    Report,
  },
  data() {
    return {
      header: [
        {
          title: "Nº Locação",
          field: "numberRent",
          fieldOrderBy: "NumberRent",
          show: true,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Cliente",
          field: "customerName",
          fieldOrderBy: "CustomerName",
          show: true,
          styleHeader: "width:250px;",
          styleBody:
            "max-width: 240px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Produto",
          field: "productName",
          fieldOrderBy: "ProductName",
          show: true,
          initialOrderBy: true,
          styleHeader: "width:300px;",
          styleBody:
            "max-width: 290px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Categoria",
          field: "categoryProductName",
          fieldOrderBy: "CategoryProductName",
          show: false,
          styleHeader: "width:160px;",
          styleBody:
            "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Fabricante",
          field: "manufacturerName",
          fieldOrderBy: "ManufacturerName",
          show: true,
          styleHeader: "width:160px;",
          styleBody:
            "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Unid. Medida",
          field: "unitOfMeasurementName",
          fieldOrderBy: "UnitOfMeasurementName",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Patrimoniado",
          field: "allowWithoutPatrimonyName",
          fieldOrderBy: "AllowWithoutPatrimonyName",
          show: false,
          styleHeader: "width:110px;",
          styleBody: "max-width: 100px;",
        },
        {
          title: "Status",
          field: "statusName",
          fieldOrderBy: "StatusName",
          show: false,
          styleHeader: "width:80px;",
          styleBody: "max-width: 70px;",
        },
        {
          title: "Situação",
          field: "situationName",
          fieldOrderBy: "SituationName",
          show: true,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Estoque",
          field: "totalStock",
          fieldOrderBy: "TotalStock",
          show: false,
          styleHeader: "width:80px;",
          styleBody: "max-width: 70px;",
        },
        {
          title: "Reservado",
          field: "totalReserved",
          fieldOrderBy: "TotalReserved",
          show: true,
          styleHeader: "width:90px;",
          styleBody: "max-width: 80px;",
        },
        {
          title: "Locado",
          field: "totalRented",
          fieldOrderBy: "TotalRented",
          show: true,
          styleHeader: "width:80px;",
          styleBody: "max-width: 70px;",
        },
        {
          title: "Devolvido",
          field: "totalReturned",
          fieldOrderBy: "TotalReturned",
          show: true,
          styleHeader: "width:90px;",
          styleBody: "max-width: 80px;",
        },
        {
          title: "Vl. Reposição",
          field: "replacementValue",
          fieldOrderBy: "ReplacementValue",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Total Reposição",
          field: "totalReplacementValue",
          fieldOrderBy: "TotalReplacementValue",
          show: false,
          styleHeader: "width:130px;",
          styleBody: "max-width: 120px;",
        },
      ],
      filters: [
        {
          type: "options",
          title: "Situação",
          field: "SituationName",
          options: [
            { text: "Reservado", value: "Reservado" },
            { text: "Locado", value: "Locado" },
            { text: "Devolvido", value: "Devolvido" },
          ],
          value: [],
        },
        {
          type: "text",
          title: "Nº Locação",
          field: "NumberRent",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Cliente",
          field: "CustomerName",
          url: "/api/v1/crm/customer/select-all-without-document",
          propsParams: { isCustomer: true, isSupplier: false },
          value: "",
        },
        {
          type: "options",
          title: "Tipo",
          field: "TypeName",
          options: [
            { text: "Equipamento", value: "Equipamento" },
            { text: "Acessório", value: "Acessório" },
            { text: "Material", value: "Material" },
            { text: "Serviço", value: "Serviço" },
          ],
          value: [],
        },
        {
          type: "multiOptions",
          title: "Produto",
          field: "ProductName",
          url: "/api/v1/stock/product/select-all-with-typeProduct",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Categoria",
          field: "CategoryProductName",
          url: "/api/v1/stock/category-product/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Fabricante",
          field: "ManufacturerName",
          url: "/api/v1/stock/manufacturer/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Unid. Medida",
          field: "UnitOfMeasurementName",
          url: "/api/v1/stock/unit-of-measurement/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "options",
          title: "Patrimoniado",
          field: "AllowWithoutPatrimonyName",
          options: [
            { text: "Sim", value: "Sim" },
            { text: "Não", value: "Não" },
          ],
          value: [],
        },
        {
          type: "options",
          title: "Status",
          field: "StatusName",
          options: [
            { text: "Ativo", value: "Ativo" },
            { text: "Inativo", value: "Inativo" },
          ],
          value: [],
        },
        /*   {
          type: "number",
          title: "Estoque",
          field: "TotalStock",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Reservado",
          field: "TotalReserved",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Locado",
          field: "TotalRented",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Devolvido",
          field: "TotalReturned",
          valueStart: 0,
          valueEnd: 0,
        },*/
        {
          type: "decimal",
          title: "Vl. Reposição",
          field: "ReplacementValue",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Total Reposição",
          field: "TotalReplacementValue",
          valueStart: 0,
          valueEnd: 0,
        },
      ],
    };
  },
};
</script>
